import { cloneElement } from 'react'
import { usePermissions } from 'react-admin';

const Permissions = ({ permissions = [], children, ...props }) => {
  const { permissions: userPermissions } = usePermissions();
  return userPermissions && permissions.some(r => userPermissions.includes(r)) ? cloneElement(children, props) : null
}
export default Permissions;